import React from "react";
import { Box } from "@mui/material";
import Grid from "@metacrm/metacrm-material-ui/dist/Grid";
import { Loading } from "features/common";

const ChartLoadingPlaceholder = ({ ...props }) => {
  return (
    <Box component={Grid} item {...props}>
      <Box sx={{ position: "relative", height: "100%" }}>
        <Loading open={true} fullScreen={false} isChart={true} />
      </Box>
    </Box>
  );
};

export default ChartLoadingPlaceholder;
